export const OTP_DIGITS = 6;
export const OTP_SECONDS = 30;
